import { createSelector } from 'reselect';

export const selectFirebase = createSelector(store => store, store => store.firebase);
export const selectAssets = createSelector(selectFirebase, store => store.assets);
export const selectComments = createSelector(selectFirebase, store => store.comments);
export const selectConfig = createSelector(selectFirebase, store => store.config);
export const selectConstants = createSelector(selectFirebase, store => store.constants);
export const selectDictionary = createSelector(selectFirebase, store => store.dictionary);
export const selectGrammar = createSelector(selectFirebase, store => store.grammar);
export const selectIgnoredGrammar = createSelector(selectFirebase, store => store.ignoredGrammar);
export const selectInvites = createSelector(selectFirebase, store => store.invites);
export const selectLocalization = createSelector(selectFirebase, store => store.localization);
export const selectLocalizedKeys = createSelector(selectFirebase, store => store.localizedKeys);
export const selectLocks = createSelector(selectFirebase, store => store.locks);
export const selectNetwork = createSelector(selectFirebase, store => store.network);
export const selectNotifications = createSelector(selectFirebase, store => store.notifications);
export const selectProjects = createSelector(selectFirebase, store => store.projects);
export const selectRevisions = createSelector(selectFirebase, store => store.revisions);
export const selectSheets = createSelector(selectFirebase, store => store.sheets);
export const selectShortcuts = createSelector(selectFirebase, store => store.shortcuts);
export const selectSubtitles = createSelector(selectFirebase, store => store.subtitles);
export const selectUser = createSelector(selectFirebase, store => store.user);
export const selectTags = createSelector(selectFirebase, store => store.tags);
export const selectUsers = createSelector(selectFirebase, store => store.users);
export const selectVersions = createSelector(selectFirebase, store => store.versions);
